export const colors = {
    GREEN : '#28A745',
    BLUE : '#508FD6',
    ORANGE : '#EC930D',
    YELLOW : '#EAD51A',
    BROWN : '#A52A2A',
    GREY : '#808080'
}
